<template>
  <div class="formkit-outer" :data-family="context.family" :data-type="context.type" v-bind="dataAttributes">
    <div class="space-y-3">
      <div
        v-for="(item, index) in props.context.node.props.items" :key="item.key || index"
        class="flex justify-between items-center py-2">
        <label :for="`${context.id}-${item.key}`" class="flex-1 text-sm font-medium text-gray-700">
          {{ item.label }} :
        </label>

        <div class="flex items-center">
          <InputNumber
            :id="`${context.id}-${item.key}`" v-model="values[item.label]" :data-key="item.key"
            :min="getMinValue(item)" :max="getMaxValue(item)" :step="getStepValue(item)" show-buttons
            button-layout="horizontal" :pt="{
              root: { class: 'w-auto' },
              pcInputText: {
                root: {
                  class: 'text-center text-sm py-2 px-2',
                  style: { width: '4rem' },
                },
              },
            }" :aria-label="`Quantité ${item.label}`"
            @update:model-value="(value) => handleValueChange(item.label, value)" />
        </div>
      </div>
    </div>

    <div
      v-if="
        context.state.messages && Object.keys(context.state.messages).length > 0
      " class="mt-3 formkit-messages">
      <div
        v-for="(message, key) in context.state.messages" :key="key"
        class="p-2 text-sm text-red-600 bg-red-50 rounded border border-red-200 formkit-message"
        :data-message-type="message.type || 'validation'">
        {{ message.value || message }}
      </div>
    </div>

    <div
      v-if="context.help && context.attrs.helpPosition === 'below'" class="mt-2 text-xs text-gray-600 formkit-help"
      v-html="context.help" />

    <div v-if="isDebug" class="p-2 mt-2 text-xs bg-gray-100">
      <strong>Debug Info:</strong><br >
      <strong>Items received:</strong>
      {{ JSON.stringify(props.context.node.props.items, null, 2) }}<br >
      <strong>Processed items:</strong>
      {{ JSON.stringify(values, null, 2) }}
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import InputNumber from "primevue/inputnumber";

const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
  isDebug: {
    type: Boolean,
    default: false,
  },
});

const values = ref({});
const items = ref(
  props.context.items ??
  props.context.attrs?.items ??
  props.context.node?.props?.items,
);

const dataAttributes = Object.entries(props.context.attrs)
  .filter(([attr, _value]) => attr.includes("data-"))
  .map(([attr, value]) => ({
    [attr]: value,
  }))
  .reduce((acc, obj) => ({ ...acc, ...obj }), {});
const handleValueChange = (key, newValue) => {
  const numValue = newValue !== null && newValue !== undefined ? newValue : 0;
  values.value[key] = numValue;
  updateFormKitValue();
};

const getMinValue = (item) => {
  return item?.min !== undefined ? item.min : 0;
};

const getMaxValue = (item) => {
  return item?.max !== undefined ? item.max : 999;
};

const getStepValue = (item) => {
  return item?.step !== undefined ? item.step : 1;
};

const updateFormKitValue = () => {
  props.context.node.input({ ...values.value });
};
const initializeValues = () => {
  const currentValue = props.context._value || {};
  const newValues = {};
  props.context.node.props.items?.forEach((item) => {
    newValues[item.label] =
      currentValue[item.label] !== undefined
        ? currentValue[item.label]
        : (item?.defaultValue ?? item?.min ?? 0);
  });
  values.value = newValues;
  updateFormKitValue();
};
onMounted(() => {
  initializeValues();
});
</script>
